import { render, staticRenderFns } from "./PracticeProviders.vue?vue&type=template&id=5af5e6cf&scoped=true&"
import script from "./PracticeProviders.vue?vue&type=script&lang=js&"
export * from "./PracticeProviders.vue?vue&type=script&lang=js&"
import style0 from "./PracticeProviders.vue?vue&type=style&index=0&id=5af5e6cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af5e6cf",
  null
  
)

export default component.exports